import { render, staticRenderFns } from "./GovtCert.vue?vue&type=template&id=66bc1271"
import script from "./GovtCert.vue?vue&type=script&lang=js"
export * from "./GovtCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66bc1271')) {
      api.createRecord('66bc1271', component.options)
    } else {
      api.reload('66bc1271', component.options)
    }
    module.hot.accept("./GovtCert.vue?vue&type=template&id=66bc1271", function () {
      api.rerender('66bc1271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/GovtCert.vue"
export default component.exports